import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import apiService from './services/api';

const SignInModal = ({ onClose, onSignInSuccess }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleGoogleSuccess = async (credentialResponse) => {
        setIsLoading(true);
        setError(null);
        
        try {
            console.log('Google sign-in successful:', credentialResponse);
            
            // Call our backend API
            const response = await apiService.googleSignIn(credentialResponse.credential);
            
            console.log('Backend response:', response);
            
            if (response.user && response.token) {
                // Call the success callback with user data
                onSignInSuccess(response.user);
                onClose();
            } else {
                setError('Sign in failed. Please try again.');
            }
        } catch (error) {
            console.error('Sign in error:', error);
            setError('Sign in failed: ' + error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleGoogleError = (error) => {
        console.error('Google sign-in failed:', error);
        setError('Google sign-in failed. Please try again.');
    };

    const handleTestLogin = async () => {
        setIsLoading(true);
        setError(null);
        
        try {
            // Use localhost for development since external routing is not working
            const response = await fetch('http://localhost:8000/api/auth/test-login/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: 'test.investor@example.com'
                })
            });
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            console.log('Test login response:', data);
            
            if (data.user && data.token) {
                // Set token in API service
                apiService.setToken(data.token);
                
                // Call success callback
                onSignInSuccess(data.user);
                onClose();
            } else {
                setError('Test login failed. Please try again.');
            }
        } catch (error) {
            console.error('Test login error:', error);
            setError('Test login failed: ' + error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
    };

    return (
        <div className="modal-overlay" onClick={handleClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Sign In</h2>
                    <button className="close-button" onClick={handleClose}>×</button>
                </div>
                <div className="modal-body">
                    <p>Choose your sign-in method:</p>
                    <div className="sign-in-options">
                        {isLoading ? (
                            <div className="loading-state">
                                <div className="loading-spinner"></div>
                                <p>Signing in...</p>
                            </div>
                        ) : (
                            <div>
                                <div className="google-login-container">
                                    <GoogleLogin
                                        onSuccess={handleGoogleSuccess}
                                        onError={handleGoogleError}
                                        useOneTap={false}
                                        theme="filled_blue"
                                        size="large"
                                        text="continue_with"
                                        shape="rectangular"
                                    />
                                </div>
                            </div>
                        )}
                        
                        {error && (
                            <div className="error-message">
                                {error}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignInModal; 